import { Box, Grid, Typography } from '@mui/material';
import { ReactElement } from 'react';

const LeastPriv = (data: any): any => {
  if (data?.least_privilege_available === true) return 'Yes';
  if (data?.least_privilege_available === false) return 'No';
  return '-';
};

const TentantIso = (data: any): any => {
  if (data?.tenant_isolation_support === true) return 'Yes';
  if (data?.tenant_isolation_support === false) return 'No';
  return '-';
};

const IdentityAndAccess = ({ data }: any): ReactElement => (
  <Box>
    <Grid container spacing={3}>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">
          Authentication Method
        </Typography>
        <Typography sx={{ textTransform: 'capitalize' }}>
          {data?.auth_method || '-'}
        </Typography>
      </Grid>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">Identity Provider</Typography>
        <Typography>{data?.identity_provider || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Authorization Model
        </Typography>
        <Typography sx={{ textTransform: 'capitalize' }}>
          {data?.authorization_model || '-'}
        </Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Required Roles/Permissions
        </Typography>
        <Typography>{data?.required_roles_permissions || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">
          Least Privilege Available
        </Typography>
        <Typography>{LeastPriv(data)}</Typography>
      </Grid>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">
          Human vs Machine Access
        </Typography>
        <Typography sx={{ textTransform: 'capitalize' }}>
          {data?.human_vs_machine_access || '-'}
        </Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Secrets Management Approach
        </Typography>
        <Typography>{data?.secrets_management_approach || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">
          Token Lifetime & Rotation
        </Typography>
        <Typography>{data?.token_lifetime_rotation || '-'}</Typography>
      </Grid>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">
          Tenant Isolation Support
        </Typography>
        <Typography>{TentantIso(data)}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Break-Glass / Admin Override
        </Typography>
        <Typography>{data?.break_glass_details || '-'}</Typography>
      </Grid>
    </Grid>
  </Box>
);

export default IdentityAndAccess;
